import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import './style/font/font.css'
import moment from 'moment'
Vue.prototype.$moment = moment
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import {
    Tab,
    Tabs,
    Overlay,
    Icon,
    Calendar,
    Collapse,
    CollapseItem,
    Toast,
    Tag,
    Search,
    Button,
    Cascader,
    Popup,
    Picker,
    Empty,
    List,
    Loading,
    DatetimePicker,
    Divider,
    Checkbox,
    CheckboxGroup,
    NavBar
} from 'vant'
import 'vant/lib/index.css'
import '@/utils/rem'
import LoadingComponent from './components/Loading'
import FastClick from 'fastclick'
import BaiduMap from "vue-baidu-map"

FastClick.attach(document.body)

import HistoryToday from '@/pages/Integral/views/components/HistoryToday/index'

Vue.component('HistoryToday', HistoryToday)

Vue.use(BaiduMap, {ak: 'jvFgBvl4VqYwwo1aCy9fOGFs8Q2HrL3Y'})
    .use(Element)
    .use(Tab)
    .use(Tabs)
    .use(Overlay)
    .use(Icon)
    .use(Calendar)
    .use(Collapse)
    .use(CollapseItem)
    .use(Tag)
    .use(Search)
    .use(Button)
    .use(Toast)
    .use(Cascader)
    .use(Popup)
    .use(Picker)
    .use(Empty)
    .use(List)
    .use(Loading)
    .use(DatetimePicker)
    .use(Divider)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(NavBar)

Vue.config.productionTip = false

Vue.component('LoadingComponent', LoadingComponent)

Vue.directive('debounce', {  // Vue2 全局自定义指令 - 防抖
    bind(el, binding) {
        let throttleTime = binding.value; // 防抖时间
        if (!throttleTime) { // 用户若不设置防抖时间，则默认2s
            throttleTime = 2000
        }
        let cbFun
        el.addEventListener('click', event => {
            if (!cbFun) { // 第一次执行
                cbFun = setTimeout(() => {
                    cbFun = null;
                }, throttleTime)
            } else {
                event && event.stopImmediatePropagation();
            }
        }, true)
    }
})

Vue.prototype.isIOS = function () {
    let u = navigator.userAgent;
    let iOs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    return iOs
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#profile')
